import React from "react"
import { InfoIcon } from "components/page-components/Icons/small"
import { ArticleContentComponentContainer } from "../utils"

export const InfoBox = ({ content, title }) => {
  return (
    <ArticleContentComponentContainer>
      <div className="has-background-mitternachtsblau-10 info-box my-4">
        <div className="columns is-mobile pt-2 py-1">
          <div className="column is-1 has-text-centered pr-0">
            <InfoIcon {...{ size: 1 }} />
          </div>
          <div className="column pr-5 pt-2">
            {!!title ? (
              <p className="has-text-weight-bold has-text-mitternachtsblau">
                {title}
              </p>
            ) : null}
            <div
              className="has-text-mitternachtsblau"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      </div>
    </ArticleContentComponentContainer>
  )
}
